import React, { useContext } from "react";
import AuthContext from "context/AuthContext";
import LeafletMapAssetContainer from "./LeafletMapAssetContainer";
import AzureMapAssetsContainer from "./AzureMapAssetsContainer";

const toNumber = (v) => {
    if (v === null || v === undefined) return null;
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : null;
};

const parseCenter = (c) => {
    if (!c) return null;
    if (c.length >= 2) {
        const lat = toNumber(c[0]);
        const lng = toNumber(c[1]);
        if (lat !== null && lng !== null) return [lat, lng];
    }
    if (typeof c === 'object' && c.lat !== undefined && c.lng !== undefined) {
        const lat = toNumber(c.lat);
        const lng = toNumber(c.lng);
        if (lat !== null && lng !== null) return [lat, lng];
    }
    return null;
};

const computeCenterFromWaypoints = (wps) => {
    if (!wps || !wps.length) return null;
    const pts = wps
        .map(w => ({ lat: toNumber(w.lat), lng: toNumber(w.lng) }))
        .filter(p => p.lat !== null && p.lng !== null);
    if (!pts.length) return null;
    if (pts.length === 1) return [pts[0].lat, pts[0].lng];
    let minLat = pts[0].lat, maxLat = pts[0].lat, minLng = pts[0].lng, maxLng = pts[0].lng;
    pts.forEach(p => {
        if (p.lat < minLat) minLat = p.lat;
        if (p.lat > maxLat) maxLat = p.lat;
        if (p.lng < minLng) minLng = p.lng;
        if (p.lng > maxLng) maxLng = p.lng;
    });
    return [(minLat + maxLat) / 2, (minLng + maxLng) / 2];
};

const normalizeWaypoints = (wps) => (wps || []).map(w => ({
    ...w,
    lat: toNumber(w.lat),
    lng: toNumber(w.lng)
})).filter(w => w.lat !== null && w.lng !== null);

const MapAssetsContainer = (props) => {
    const { panel } = useContext(AuthContext);
    const provider = props.provider || panel?.map_type || 'lf';

    // Normalizar waypoints y elegir centro preferente
    const waypoints = normalizeWaypoints(props.waypoints || []);
    const centerFromWaypoints = waypoints.length ? computeCenterFromWaypoints(waypoints) : null;
    const center = centerFromWaypoints || parseCenter(props.center) || parseCenter(panel?.coords) || [0, 0];

    const passed = { ...props, center, waypoints };

    if (provider === 'az') {
        return <AzureMapAssetsContainer {...passed} />;
    }

    return <LeafletMapAssetContainer {...passed} />;
};

export default MapAssetsContainer;
